<script lang="ts">
	export let text: string;
	export let pathname: string;
	export let href: string;

	$: active = pathname === href;
</script>

<a
	class="flex hover:no-underline item"
	class:selected={active}
	data-sveltekit-preload-data="hover"
	{href}
>
	{text}
</a>

<style>
	.item {
		display: flex;
		padding: 11px 16px 12px 16px;
		justify-content: center;
		align-items: center;
		flex: 1 0 0;

		color: var(--gray-50, #a7a7a7);
		text-align: center;

		/* body-B-06 */
		font-size: 18px;
		font-family: Lato;
		font-style: normal;
		font-weight: 700;
	}
	.selected {
		border-radius: 8px;
		background: var(--p-60, #49b4b1);
		box-shadow: 0px 0px 16px 0px rgba(189, 243, 241, 0.6) inset;

		color: var(--white, #fff);
	}
</style>
